<template>
  <div id="inspeccion">
    <div class="section">
      <div class="container fadeInUp wow" data-wow-duration="0.5s" >
          <h3>Inspección Técnica de Obras</h3>
            <div class="line bg-primary mb-5"></div>
            <div class="row">
              <div class="col-md-6 mb-4">
                <img
                class="img-fluid w-100"
                src="../assets/product/inspeccion.jpg"
                alt="Inspección"
                height="300"
              />
              </div>
              <div class="col-md-6 mb-4 d-none d-md-block">
                <img
                class="img-fluid w-100"
                src="../assets/product/inspeccion1.jpg"
                alt="Inspección"
                height="300"
              />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                Desarrollamos la coordinación técnica para la Inspección del Proyecto. Contamos con profesionales del área con experiencia para inspeccionar las especialidades de acuerdo a las especificaciones e introducimos mejoras aprobadas por los proyectistas que impactan en la eficiencia presupuestaria. <br><br>
                Inspeccionamos, Controlamos y Dirigimos las Obras con contratistas, proyectistas, proveedores, Stakeholders del mandante y organismos públicos.
                Nuestras principales áreas de la inspección de obras son:
                <ul class="mb-0 mt-3">
                  <li>Licitación de Contratos.</li>
                  <li>Entrega de terreno a Contratista.</li>
                  <li>Entrega de todos los antecedentes técnicos “apto para construcción”, tales como planos, especificaciones técnicas, set de aclaraciones, fichas, catálogos, otros.</li>
                  <li>Coordinación con arquitectos y proyectistas de espacialidades.</li>
                </ul>
              </div>
              <div class="col-md-6 mb-4">
                <ul>
                  <li>Auditoria de la Gestión de Calidad del Contratista, verificando y registrando el cumplimiento del autocontrol.</li>
                  <li>Revisión y protocolización de partidas, según criterios a definir con el Cliente.</li>
                  <li>Medición y control del programa de obra, revisión y validación de los estados de pago.</li>
                  <li>Revisión de adicionales de obra.</li>
                  <li>Fiscalizar el cumplimiento de las condiciones de Seguridad, Prevención de Riesgos y cumplimientos laborales.</li>
                  <li>Recepciones Provisoria de Obras.</li>
                  <li>Recepción final de Obra.</li>
                  <li>Coordinación para la obtención de los certificados emitidos por organismos públicos y privados para Recepción Municipal de la Obra.</li>
                  <li>Cierre contractual de proyecto con documentación legal en regla.</li>
                </ul>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspeccion",
};
</script>
